<template>
<div class="page-wrapper">
	<div class="page page-settings">
		<div class="container">
			<div class="page-header">
				<h1 class="page-title">
					<router-link class="text" to="/settings">Settings</router-link>
					<i class="separator material-icons">chevron_right</i>
					<span class="page-breadcrumb">SMS Gateway</span>
				</h1>
			</div>
			<div class="page-content">
				<div class="box p-0">
					<!-- Zenziva -->
					<div class="integration-item">
						<div class="integration-app">
							<div class="wrapper">
								<div class="integration-app-logo">
									<img src="/images/logo-small-zenziva.png" alt="Zenziva">
								</div>
								<button type="button" class="integration-app-button btn btn-primary" v-if="zenzivaAccounts.length === 0" @click="isShowModalZenziva = true">+ Add Zenziva Account</button>
							</div>
						</div>
						<integration-accounts
							:name="'Zenziva Account'"
							:accounts="zenzivaAccounts"
							@remove="removeIntegration">
						</integration-accounts>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="modals">
		<!-- Zenizva -->
		<modal class="integration-modal" :size="'large'" v-if="isShowModalZenziva" @close="isShowModalZenziva = false">
			<div slot="header"><h3>Zenziva</h3></div>
			<div slot="body" class="row">
				<!-- Tutorial -->
				<div class="col-lg-6">
					<h4 class="modal-title">How to Integrate</h4>
					<div class="integration-video embed-responsive embed-responsive-16by9">
						<iframe src="https://www.youtube.com/embed/ydZDZMcdJRA?rel=0"></iframe>
					</div>
				</div>
				<!-- Config -->
				<div class="col-lg-6">
					<h4 class="modal-title">Configurations</h4>
					<div class="integration-actions">
						<form class="form" @submit.prevent="addZenziva">
							<div class="form-group">
								<input type="text" class="input form-control" placeholder="Username" v-model="zenzivaUsername" required>
							</div>
							<div class="form-group">
								<multiselect
									v-model="zenzivaAccountType"
									placeholder="Account Type"
									label="name"
									track-by="name"
									:searchable="false"
									:options="zenzivaAccountTypes"
									:show-labels="false"
									:preselect-first="true"
									:allow-empty="false">
									<span slot="noResult">Not found</span>
								</multiselect>
							</div>
							<div class="form-group">
								<input type="text" class="input form-control" placeholder="Userkey" v-model="zenzivaUserkey" required>
							</div>
							<div class="form-group">
								<input type="text" class="input form-control" placeholder="Passkey" v-model="zenzivaPasskey" required>
							</div>
							<div class="form-group" v-if="zenzivaAccountType && zenzivaAccountType.value === 'center_v2'">
								<input type="text" class="input form-control" placeholder="Subdomain" v-model="zenzivaSubdomain" @input="onSubdomainChange" required>
							</div>
							<div class="text-right">
								<button
									type="submit"
									class="btn btn-primary"
									:class="{ 'is-loading': isAddingZenziva }"
									>Integrate
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
			<div slot="footer">
				<button class="btn btn-light" @click="isShowModalZenziva = false">{{ $t('Close') }}</button>
			</div>
		</modal>
	</div>

	<notifications group="sms" position="bottom right" />
</div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from 'vuex';
import Modal from '../components/Modal.vue';
import IntegrationAccounts from '../components/IntegrationAccounts.vue';
import { zenzivaAccountTypes } from '../lib/statics';
import { duplicateVar } from '../lib/helper';
import integrationApi from '../api/integration';

export default {
	name: 'settingsSms',
	components: {
		Modal,
		IntegrationAccounts,
	},
	data() {
		return {
			zenzivaUsername: '',
			zenzivaAccountType: null,
			zenzivaAccountTypes,
			zenzivaUserkey: '',
			zenzivaPasskey: '',
			zenzivaSubdomain: '',
			isCorrectAccountType: false,
			isShowModalZenziva: false,
			isAddingZenziva: false,
		};
	},
	methods: {
		...mapActions({
			fetchAccounts: 'settings/fetchAccounts',
			addAccount: 'settings/addAccount',
			removeAccount: 'settings/removeAccount',
		}),
		removeIntegration(id) {
			this.removeAccount(id);
			const callback = (response) => {
				// console.log(response);
			};
			integrationApi.remove(id, callback);
		},
		addZenziva() {
			this.isAddingZenziva = true;

			if (!this.zenzivaAccountType) {
				this.$notify({
					group: 'sms',
					title: 'Zenziva',
					text: 'Please select account type',
					type: 'error',
				});
				this.isAddingZenziva = false;
				return false;
			}

			const username = this.zenzivaUsername;
			const accountType = this.zenzivaAccountType.value;
			const userkey = this.zenzivaUserkey;
			const passkey = this.zenzivaPasskey;

			const params = {
				username: username,
				account_type: accountType,
				userkey: userkey,
				passkey: passkey,
			};

			if (accountType === 'center_v2') {
				params.subdomain = duplicateVar(this.zenzivaSubdomain);
			}

			const callback = (response) => {
				const account = response.data;
				if (account !== '') {
					this.addAccount(account);
				}
				this.isAddingZenziva = false;
				this.isShowModalZenziva = false;

				this.$notify({
					group: 'sms',
					title: 'Zenziva',
					text: 'Successfully Connected to Zenziva',
					type: 'success',
				});
			};

			const errorCallback = (e) => {
				if (e.response) {
					const response = e.response.data;
					const errorMessage = response.message;
					this.$notify({
						group: 'sms',
						title: 'Zenziva',
						text: errorMessage,
						type: 'error',
					});
				}
				this.isAddingZenziva = false;
			};
			integrationApi.addZenziva(params, callback, errorCallback);
		},
		onSubdomainChange(event) {
			const value = event.target.value;
			const regex = /[^a-zA-Z0-9]+/ig;
			const subdomain = value.replace(regex, '').toLowerCase();
			this.zenzivaSubdomain = subdomain;
		},
	},
	computed: {
		...mapGetters({
			isFetching: 'settings/isFetching',
			accounts: 'settings/accounts',
		}),
		zenzivaAccounts() {
			return this.accounts.filter(account => account.name === 'zenziva');
		},
	},
	created() {
		if (!this.isFetching) {
			this.fetchAccounts();
		}
	},
};
</script>
